import React from 'react';

import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  shipmentCounter: {
    description: 'Label indicating a specific shipment',
    defaultMessage: 'Shipment {counter}',
    id: 'S69fEL',
  },
});

const ShipmentCounter = ({ counter }) => <FormattedMessage {...messages.shipmentCounter} values={{ counter }} />;

export { ShipmentCounter };

ShipmentCounter.propTypes = {
  counter: PropTypes.number.isRequired,
};
